import { render } from "./fiveTreeSelect.vue?vue&type=template&id=083fc11d&scoped=true"
import script from "./fiveTreeSelect.vue?vue&type=script&lang=js"
export * from "./fiveTreeSelect.vue?vue&type=script&lang=js"

import "./fiveTreeSelect.vue?vue&type=style&index=0&id=083fc11d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083fc11d"]])

export default __exports__